import { useMediaMatcher } from "@asosteam/asos-web-component-library-breakpoints";

const useCarouselPageSize = () => {
  const queryMatches = useMediaMatcher();

  return parseInt(Object.keys(queryMatches).find(key => queryMatches[key]));
};

export default useCarouselPageSize;
